import React from 'react';
import {Button, Link} from '@mui/material';
import {darken} from "polished";
import {styled} from "@mui/material/styles";

type ButtonStyleProps = {
    $color: string,
    $outline?: boolean
}
const ButtonStyle = styled(Button)<ButtonStyleProps>(({ theme, $color, $outline }) => ({
    color: $color ? $color : 'blue',
    ...( $outline && {
        color: `${theme.palette[$color]}`,
        background: 'none',
        border: `1px solid ${theme.palette[$color]}`,
        '&:hover' : {
            background: `${theme.palette[$color]}`,
            color: 'white',
        },
        '&:active' : {
            background: `${darken(0.1, theme.palette[$color])}`,
            color: 'white'
        }
    })
}));

interface ButtonCompProps {
    to?: string
    color: string
    size?: 'small' | 'medium' | 'large'
    outline?: boolean
    disable?: boolean
    children?: string
    className?: string
    onClick?: (e: any) => void
}

const ButtonComp = ({ to, color, size, outline, disable, children, ...rest }: ButtonCompProps) => {
    return to ? (
        <Link href={to} {...rest} > {children} </Link>
    ) : (
        <ButtonStyle $color={color} size={size} $outline={outline} disabled={disable} {...rest} > {children} </ButtonStyle>
    );
};

export default ButtonComp;
